import { render, staticRenderFns } from "./StatusField.vue?vue&type=template&id=4b0de8dc&"
import script from "./StatusField.vue?vue&type=script&lang=js&"
export * from "./StatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports